import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';

import { ImportService } from '../../../shared/basic-data-management/import-service.class';

import { ImportDialogComponent, ImportDialogData } from './import-dialog.component';

@Component({
	selector: 'import-button',
	templateUrl: 'import-button.html',
})
export class ImportButtonComponent {
	openDialogRequests$ = new Subject<void>();	
	private service$ = new Subject<ImportService>();
	
	constructor(
		dialog: MatDialog,
	) {
		this.openDialogRequests$.pipe(
			withLatestFrom(this.service$),
		).subscribe(
			([_, importService]) => {
				let dialogRef = dialog.open(ImportDialogComponent, {
					width: '600px',
					panelClass: 'aurora-dialog-container',
					data: {
						service: importService,
					} as ImportDialogData,
					disableClose: true,
				});

				dialogRef.afterClosed().subscribe(
					(dataImported) => {
						if (dataImported) {
							this.dataImported.emit()
						}
					}
				);
			}
		)
	}
	
	@Input() class: string = "btn btn-primary";
	
	// Doit etre equivalant au nom de la classe d'entities Java importe
	@Input() set service(service: ImportService) {
		this.service$.next(service);
	}
	
	@Output() dataImported = new EventEmitter<void>();
}